import { SaveButton, SimpleForm, Toolbar, useCreate, useCreateSuggestionContext } from 'react-admin'
import { CreateModal, UpsertCustomer } from '~/components'

const CreateCustomer = () => {
  const { filter, onCancel, onCreate } = useCreateSuggestionContext()
  const [create] = useCreate()
  const defaultValues = () => {
    const [first, last] = filter?.split(' ') || []
    return {
      firstname: last ? first : '',
      lastname: last || first,
    }
  }

  // react-admin 4's useCreate takes (resource, { data }, options), and
  // onSuccess receives the created record rather than { data }.
  const handleSubmit = (values) => {
    create('customers', { data: { ...values } }, { onSuccess: (record) => onCreate(record) })
  }

  return (
    <CreateModal title='resources.customers.create' open onClose={onCancel} resource='customers'>
      <SimpleForm
        onSubmit={handleSubmit}
        defaultValues={defaultValues}
        toolbar={
          <Toolbar>
            <SaveButton alwaysEnable />
          </Toolbar>
        }
      >
        <UpsertCustomer essentialOnly />
      </SimpleForm>
    </CreateModal>
  )
}

export default CreateCustomer
